import styled, {
  createGlobalStyle,
  css,
} from 'styled-components';

export const Flex = css`
  display: flex;
`;

export const FlexCol = css`
  display: flex;
  flex-direction: column;
`;

export const FlexRowCenter = css`
  ${Flex};
  justify-content: center;
  align-items: center;
`;

export const FlexRowStart = css`
  ${Flex};
  justify-content: flex-start;
  align-items: center;
`;

export const FlexRowEnd = css`
  ${Flex};
  justify-content: flex-end;
  align-items: center;
`;

export const FlexRowBetween = css`
  ${Flex}
  justify-content: space-between;
  align-items: center;
`;

export const FlexRowAround = css`
  ${Flex}
  justify-content: space-around;
  align-items: center;
`;

export const FlexColCenter = css`
  ${FlexCol};
  ${FlexRowCenter}
`;

export const FlexColStart = css`
  ${FlexCol};
  justify-content: flex-start;
  align-items: flex-start;
`;

export const FlexColEnd = css`
  ${FlexCol};
  justify-content: flex-end;
  align-items: flex-end;
`;

export const FlexColBetween = css`
  ${FlexCol};
  justify-content: space-between;
  align-items: baseline;
`;

export const BackgroundCover = css`
  ${'' /* background-image: url(${props =>
    props.bgUrl && props.bgUrl});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat; */}
`;

export const BackgroundContain = css`
  ${BackgroundCover};
  background-size: contain;
`;

export const LoadingWrapper = styled.div`
  width: 100%;
  height: 100%;
  ${FlexRowCenter};
`;

export const Container = styled.div`
  /* max-width: 100% !important; */
  width: 100%;
  padding: 0 25px;
  @media (min-width: 768px) and (max-width: 1180px) {
    padding: 0 16px;
  }
`;

/* istanbul ignore next */
export const GlobalStyle = createGlobalStyle`
  :root {
    --color-theme: #D1005C;
    --color-green: #2EC26A;
    --color-blue: #007AFF;
    --color-yellow: #F0C330;
    --color-red: #E54D42;
    --color-smoke: #969FA7;
    --color-dark: #212121;
    --color-dark-2: #393839;
    --color-dark-3: #191919;
    --color-light: #E3E8EE;
    --transition-smooth: all 0.5s cubic-bezier(0.04, 1, 0.6, 0.97);
    --transition-smooth-2: all 1.5s cubic-bezier(0.04, 1, 0.6, 0.97);
    --fontSize-h1: 32px;
    --fontSize-h2: 28px;
    --fontSize-h3: 24px;
    --fontSize-h4: 20px;
    --fontSize-h5: 16px;
  }
  ${'' /* * {
    user-select: none;
  } */}
  /* input {
    user-select: initial;
  } */
  small {
    font-size: 12px;
  }
  ${
    '' /* .eHlCMj {
    pointer-events: initial;
  } 
  *{
    margin: 0;
    padding: 0;
    pointer-events: initial !important;
  }*/
  }
  *{
    margin: 0;
    padding: 0;
  }
  html,
  body {
    height: 100%;
    width: 100%;
    // color: #fff;
    background: var(--color-dark);
    font-size: 16px;
    line-height: 1.5;
    font-family: 'Inter', sans-serif;
  }

  body.fontLoaded {
    /* font-family: 'Roboto', 'Helvetica Neue', Helvetica, Arial, sans-serif; */
    font-family: 'Inter', sans-serif;
  }
  h1, .h1 {
    font-size: var(--fontSize-h1);
  }
  h2, .h2 {
    font-size: var(--fontSize-h2);
  }
  h3, .h3 {
    font-size: var(--fontSize-h3);
  }
  h4, .h4 {
    font-size: var(--fontSize-h4);
  }
  h5, .h5 {
    font-size: var(--fontSize-h5);
  }

  p,
  label {
    line-height: 1.5em;
  }

  /* input, select, button {
    font-family: inherit;
    font-size: inherit;
  } */

  ui, li {
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
  }

  .fullWidth {
    width: 100% !important;
  }

  .fullHeight {
    height: 100% !important;
  }


  /* .icon {
    width: 1.5rem;
    height: 1.5rem;
  } */

  #root {
    width: 100%;
    height: 100%;
  }
  ::-webkit-scrollbar {
    background: transparent;
    width: 5px;
    height: 5px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 9px;
    background: #c8c8c8;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: rgb(136, 136, 136);
  }
`;
